// This file is auto-generated by @hey-api/openapi-ts

import type { Options as ClientOptions, TDataShape, Client } from './client';
import type {
	GetGameGamesGameIdGetData,
	GetGameGamesGameIdGetResponses,
	GetGameGamesGameIdGetErrors,
	GetGamesByStateGamesStateStateAbbrGetData,
	GetGamesByStateGamesStateStateAbbrGetResponses,
	GetGamesByStateGamesStateStateAbbrGetErrors,
	GetAllStatesStatesGetData,
	GetAllStatesStatesGetResponses,
	GetStateStatesAbbrGetData,
	GetStateStatesAbbrGetResponses,
	GetStateStatesAbbrGetErrors,
	GetLatestReportGamesGameIdReportsLatestGetData,
	GetLatestReportGamesGameIdReportsLatestGetResponses,
	GetLatestReportGamesGameIdReportsLatestGetErrors,
	GetReportsInRangeGamesGameIdReportsGetData,
	GetReportsInRangeGamesGameIdReportsGetResponses,
	GetReportsInRangeGamesGameIdReportsGetErrors,
	RootGetData,
	RootGetResponses,
	HealthHealthGetData,
	HealthHealthGetResponses,
	DebugDbDebugDbGetData,
	DebugDbDebugDbGetResponses
} from './types.gen';
import { client as _heyApiClient } from './client.gen';

export type Options<
	TData extends TDataShape = TDataShape,
	ThrowOnError extends boolean = boolean
> = ClientOptions<TData, ThrowOnError> & {
	/**
	 * You can provide a client instance returned by `createClient()` instead of
	 * individual options. This might be also useful if you want to implement a
	 * custom client.
	 */
	client?: Client;
	/**
	 * You can pass arbitrary values through the `meta` object. This can be
	 * used to access values that aren't defined as part of the SDK function.
	 */
	meta?: Record<string, unknown>;
};

/**
 * Get Game
 */
export const getGameGamesGameIdGet = <ThrowOnError extends boolean = false>(
	options: Options<GetGameGamesGameIdGetData, ThrowOnError>
) => {
	return (options.client ?? _heyApiClient).get<
		GetGameGamesGameIdGetResponses,
		GetGameGamesGameIdGetErrors,
		ThrowOnError
	>({
		url: '/games/{game_id}',
		...options
	});
};

/**
 * Get Games By State
 */
export const getGamesByStateGamesStateStateAbbrGet = <ThrowOnError extends boolean = false>(
	options: Options<GetGamesByStateGamesStateStateAbbrGetData, ThrowOnError>
) => {
	return (options.client ?? _heyApiClient).get<
		GetGamesByStateGamesStateStateAbbrGetResponses,
		GetGamesByStateGamesStateStateAbbrGetErrors,
		ThrowOnError
	>({
		url: '/games/state/{state_abbr}',
		...options
	});
};

/**
 * Get All States
 */
export const getAllStatesStatesGet = <ThrowOnError extends boolean = false>(
	options?: Options<GetAllStatesStatesGetData, ThrowOnError>
) => {
	return (options?.client ?? _heyApiClient).get<
		GetAllStatesStatesGetResponses,
		unknown,
		ThrowOnError
	>({
		url: '/states/',
		...options
	});
};

/**
 * Get State
 */
export const getStateStatesAbbrGet = <ThrowOnError extends boolean = false>(
	options: Options<GetStateStatesAbbrGetData, ThrowOnError>
) => {
	return (options.client ?? _heyApiClient).get<
		GetStateStatesAbbrGetResponses,
		GetStateStatesAbbrGetErrors,
		ThrowOnError
	>({
		url: '/states/{abbr}',
		...options
	});
};

/**
 * Get Latest Report
 */
export const getLatestReportGamesGameIdReportsLatestGet = <ThrowOnError extends boolean = false>(
	options: Options<GetLatestReportGamesGameIdReportsLatestGetData, ThrowOnError>
) => {
	return (options.client ?? _heyApiClient).get<
		GetLatestReportGamesGameIdReportsLatestGetResponses,
		GetLatestReportGamesGameIdReportsLatestGetErrors,
		ThrowOnError
	>({
		url: '/games/{game_id}/reports/latest',
		...options
	});
};

/**
 * Get Reports In Range
 */
export const getReportsInRangeGamesGameIdReportsGet = <ThrowOnError extends boolean = false>(
	options: Options<GetReportsInRangeGamesGameIdReportsGetData, ThrowOnError>
) => {
	return (options.client ?? _heyApiClient).get<
		GetReportsInRangeGamesGameIdReportsGetResponses,
		GetReportsInRangeGamesGameIdReportsGetErrors,
		ThrowOnError
	>({
		url: '/games/{game_id}/reports',
		...options
	});
};

/**
 * Root
 */
export const rootGet = <ThrowOnError extends boolean = false>(
	options?: Options<RootGetData, ThrowOnError>
) => {
	return (options?.client ?? _heyApiClient).get<RootGetResponses, unknown, ThrowOnError>({
		url: '/',
		...options
	});
};

/**
 * Health
 */
export const healthHealthGet = <ThrowOnError extends boolean = false>(
	options?: Options<HealthHealthGetData, ThrowOnError>
) => {
	return (options?.client ?? _heyApiClient).get<HealthHealthGetResponses, unknown, ThrowOnError>({
		url: '/health',
		...options
	});
};

/**
 * Debug Db
 * Debug endpoint to check database connection and table status.
 */
export const debugDbDebugDbGet = <ThrowOnError extends boolean = false>(
	options?: Options<DebugDbDebugDbGetData, ThrowOnError>
) => {
	return (options?.client ?? _heyApiClient).get<DebugDbDebugDbGetResponses, unknown, ThrowOnError>({
		url: '/debug/db',
		...options
	});
};
